import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useQuery } from '@tanstack/react-query'
import { ApiErrorsCodes } from 'config/api'
import { useLang, useTranslate } from 'config/i18n'
import { getLang } from 'config/lang'
import { IS_PRGM_ENV, IS_SI_STATIC_DEMO } from 'constants/env'
import { projectsApi } from 'modules/projects/api'
import { ProjectsQueries } from 'modules/projects/queries/types'
import { useProfile } from 'modules/user/queries'
import { noRetryOnError } from 'packages/react-query'

export const useProject = () => {
  const { profile } = useProfile()
  const setLang = useLang((state) => state.setLang)
  const translate = useTranslate()
  const params = useParams()
  const projectId = params.projectId ? Number(params.projectId) : profile?.activeProjectId
  const enabled = !!projectId && !IS_PRGM_ENV

  const {
    data: project,
    isPending,
    error,
  } = useQuery({
    queryKey: [ProjectsQueries.Project, projectId],
    queryFn: () => {
      if (projectId) {
        return projectsApi.getProject(projectId)
      }
      return null
    },
    enabled,
    ...noRetryOnError,
    meta: {
      error: (apiError) => ({
        message:
          apiError?.code === ApiErrorsCodes.NotFound
            ? translate('projects.notFound', { projectId: String(projectId) })
            : translate('errorsNoData.project'),
        showToast: false,
      }),
    },
  })

  useEffect(() => {
    setLang(project?.language.code ?? getLang())
  }, [project])

  return {
    project,
    isLoadingProject: isPending && enabled,
    error,
    isPoc: !!project?.pocDemand,
    isForecastDemo: IS_SI_STATIC_DEMO,
  }
}
